// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"436":"b98c01e3","449":"abdb27d0","593":"0d2c5974","644":"5e3b8667","777":"cf09a9ba","789":"4b0c052b","791":"db1cca02"}[chunkId] + ".chunk.js";
};